import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=6ad37101&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=6ad37101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad37101",
  null
  
)

export default component.exports